export default {
  newDesign: true,
  parameters: {
    landing_id: "BrQTC",
    segment: 42,
    success_page: 'success_long',
  },
  title: "Receba uma aula gratuita de programação | Kodland",
  downtimeUrl: "https://www.kodland.org/pt",
  startPage: {
    title:
      "Responda 5 perguntas e receba uma aula de programação grátis para o seu filho!",
    subtitle:
      "✏️ Para crianças de 8 a 17 anos<br>💻 Criam seus primeiros projetos digitais<br>💬 Descobrimos os talentos do seu filho de forma divertida<br>🌐 Você só precisa de um computador e conexão à internet<br>💙 Já foi escolhido por mais de 100.000 pais",
    image: {
      url: "/welcome/coding_freetc_brazil_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/coding_freetc_brazil_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Reserve sua vaga 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "Você gostaria que o tempo que seu filho/filha passa no computador fosse mais produtivo?",
      answers: [
        "🔥 Sim!",
        "🤷 Não. Ele só usa para se divertir e está tudo bem"
      ],
    },
    2: {
      question: "Quais são as habilidades do seu filho com o computador?",
      answers: [
        "👍 Não tem conhecimento, precisa aprender o básico",
        "🙌 Nível básico, sabe usar PowerPoint e outros aplicativos",
        "🖥 Nível intermediário, quer aprofundar conhecimentos",
        "🎮 Usa os dispositivos mais para jogos"
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/brazil-reviews.png",
      subtitle: "Pais de todo o mundo nos recomendam. Esperamos que em breve você também se junte a eles 💙",
      button: "Vamos lá!",
    },
    4: {
      question:
        "Você tem um computador de mesa ou notebook que seu filho possa usar para estudar?",
      answers: [
        "💻 Sim",
        {
          answer: "😞 Não",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Quantos anos tem o seu filho?",
      type: "age",
      button: "",
    },
    6: {
      title: "Parabéns!",
      typeInfo: "congrats",
      subtitle:
        "Clique em “Reservar uma aula” para concluir o cadastro.",
      button: "📆 Reservar uma aula",
    },
    7: {
      title: "Agende uma aula gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Quase lá! 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Obrigado 🎉 Faltam apenas alguns passos para concluir o cadastro",
      typeInfo: "pc-laptop",
      subtitle:
        "Por favor, observe que você precisará de um PC ou laptop funcional para a aula e que deve acompanhar seu filho durante toda a aula. Lembre-se de que a aula é individual e personalizada.",
      button: "O que mais?",
    },
    10: {
      title: "Verifique seu e-mail e WhatsApp antes da aula experimental 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Enviaremos um lembrete 24 horas antes da aula e 2 horas antes da aula pediremos para você confirmar sua presença. É muito importante que mantenhamos contato para que a aula não seja cancelada.",
      button: "O que mais?",
    },
    11: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    }
  },
};
